import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import useFetchTicketDetails from '@/hooks/useApi/useFetchTicketDetails';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import TicketCommentsContainer from './TicketComments/TicketCommentsContainer';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Title, SubTitle } = vp;

type FC = FunctionComponent;
const TicketDetails: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { userSettings } = useUserSettingsProvider();
  const [ticketDetail, getTicket] = useFetchTicketDetails({});
  const { t } = useTranslation('translations', { keyPrefix: 'TicketsList.Details' });
  const { t: tTicketList } = useTranslation('translations', { keyPrefix: 'TicketsList' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const history = useHistory();

  useEffect(() => {
    getTicket({ TicketID: id, Timezone: userSettings.timezone });
  }, []);

  return (
    <div>
      <Box flx="col" mb="md" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/tickets');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : tTicketList('title')}
        </UtilButton>
        <Title title={t('pageTitle', { subject: ticketDetail?.Ticket?.subject })} />
      </Box>
      <Box mb="md" pt="sm" pb="sm">
        <SubTitle subTitle={t('subTitle', { ticketId: ticketDetail?.Ticket?.id })} variant="small" />
      </Box>
      <TicketCommentsContainer
        ticketDetail={ticketDetail}
        refreshTicket={() => {
          getTicket({ TicketID: id });
        }}
      />
    </div>
  );
};

export default TicketDetails;
